export const OrderListJsonData = (orderListInfo) => {
  // console.log(orderListInfo);

  const {
    nowpage,
    orders,
    pagecount,
    totalcount
  } = orderListInfo;

  let returnData = {
    nowPage: nowpage,
    orders: [],
    pageCount: pagecount,
    totalCount: totalcount,
  }

  let returnOrdersArray = [];
  
  orders.map((orderItem) => {
    const {
      atmPaydate,
      bankid,
      btrAcno,         // 理論上是物流單號
      buyerUnifiedCode,
      deliveryAddress, // 收件地址、理論上會在另一隻 api 上面做回傳，所以應該都沒有用
      invoiceNumber,
      invoiceType,
      isCancelOrReturn,
      isLegacyOrder,
      mobile,
      orderCode,
      orderDate,
      orderPrice,
      orderStatus,
      orderType,
      payType,
      paymentStatus,
      phone,
      pickUpName,
      receiver,
      storeId
    } = orderItem;

    let returnOrderItem = {
      member: {
        // 理論上這邊兩個變數一個是會員電話一個是收件人的電話
        mobile: mobile, // 會員電話
        phone: phone,   // 收件人電話
        // // 收貨人
        pickUpName: pickUpName,
        // // 收件人
        receiver: receiver,
        // 配送地址
        deliveryAddress: deliveryAddress,
      },

      order: {
        code: orderCode,
        date: orderDate,
        status: orderStatus,
        type: orderType,
        price: orderPrice,
      },

      payment: {
        type: payType,
        status: paymentStatus,
        // 使用 atm 付款的話會有值，顯示 atm 支付時間
        atmPayDate: atmPaydate,
        // 使用 atm 付款的話會有值，顯示支付銀行
        bankId: bankid,
        // 理論上是物流單號，要再做確認
        deliveryNo: btrAcno,
      },

      invoice: {
        number: invoiceNumber,
        type: invoiceType,
        // 發票統編
        unifiedCode: buyerUnifiedCode
      },

      config: {
        // 不知道在幹嘛的 config
        isCancelOrReturn: isCancelOrReturn,
        // 不知道在幹嘛的 config
        isLegacyOrder: isLegacyOrder,
        // 擴充區
      }
    };

    returnOrdersArray.push(returnOrderItem);
  });

  // console.log(returnOrdersArray);

  returnData.orders = returnOrdersArray;
  // console.log(JSON.stringify(returnData));

  return orderListInfo;
}

let fakeOrderListJsonData = `{"nowPage":"1","orders":[{"member":{"mobile":"0933****43","phone":"09387*****","pickUpName":"","receiver":"喵*","deliveryAddress":"&#33274;&#21271;&#24066; &#21271;&#25237;&#21312; ****23&#34399;6&#27155; "},"order":{"code":"p20745007","date":"2021-11-30","status":"已開發票","type":"電子票券","price":"$11,997"},"payment":{"type":"特力 Pay 儲值金","status":"已付款","atmPayDate":"","bankId":"","deliveryNo":""},"invoice":{"number":"MC94803157","type":"個人發票","unifiedCode":""},"config":{"isCancelOrReturn":false,"isLegacyOrder":false}},{"member":{"mobile":"0933****43","phone":"09387*****","pickUpName":"","receiver":"喵*","deliveryAddress":"&#33274;&#21271;&#24066; &#21271;&#25237;&#21312; ****23&#34399;6&#27155; "},"order":{"code":"p20736004","date":"2021-11-24","status":"已開發票","type":"電子票券","price":"$11,997"},"payment":{"type":"ATM","status":"已付款","atmPayDate":"2021-11-25 23:59:59","bankId":"013 (國泰世華)"},"invoice":{"number":"MC94803146","type":"個人發票","unifiedCode":""},"config":{"isCancelOrReturn":false,"isLegacyOrder":false}},{"member":{"mobile":"0933****43","phone":"09387*****","pickUpName":"","receiver":"喵*","deliveryAddress":"&#33274;&#21271;&#24066; &#21271;&#25237;&#21312; ****23&#34399;6&#27155; "},"order":{"code":"p20732002","date":"2021-11-22","status":"已開發票","type":"電子票券","price":"$11,997"},"payment":{"type":"ATM","status":"已付款","atmPayDate":"2021-11-23 23:59:59","bankId":"013 (國泰世華)"},"invoice":{"number":"MC94803133","type":"個人發票","unifiedCode":""},"config":{"isCancelOrReturn":false,"isLegacyOrder":false}},{"member":{"mobile":"0933****43","phone":"09387*****","pickUpName":"","receiver":"喵*","deliveryAddress":"&#33274;&#21271;&#24066; &#21271;&#25237;&#21312; ****23&#34399;6&#27155; "},"order":{"code":"p20731070","date":"2021-11-22","status":"已開發票","type":"電子票券","price":"$2,997"},"payment":{"type":"ATM","status":"已付款","atmPayDate":"2021-11-23 23:59:59","bankId":"013 (國泰世華)"},"invoice":{"number":"MC94803132","type":"個人發票","unifiedCode":""},"config":{"isCancelOrReturn":false,"isLegacyOrder":false}},{"member":{"mobile":"0933****43","phone":"09387*****","pickUpName":"","receiver":"喵*","deliveryAddress":"&#33274;&#21271;&#24066; &#21271;&#25237;&#21312; ****23&#34399;6&#27155; "},"order":{"code":"p20728002","date":"2021-11-17","status":"已開發票","type":"電子票券","price":"$3,996"},"payment":{"type":"ATM","status":"已付款","atmPayDate":"2021-11-18 23:59:59","bankId":"013 (國泰世華)"},"invoice":{"number":"MC94803114","type":"個人發票",
"unifiedCode":""},"config":{"isCancelOrReturn":true,"isLegacyOrder":false}}],"pageCount":"5","totalCount":"68"}`;

export const OrderListApiDetailJsonData = (ordersData, orderIndex, orderListDetail) => {
  // console.log(ordersData, orderIndex);
  let orderData = JSON.parse(fakeOrderListJsonData);
  // console.log(orderData);

  // 基本上只用得到會員資料，所以就先把會員資料結構出來
  let specifyOneOrderData = orderData.orders[orderIndex];
  const {
    member,
  } = specifyOneOrderData;
  // console.log(member);

  const orderEntryList = orderListDetail.orderEntryList;

  orderEntryList.map((detailItem) => {
    // console.log(detailItem);
    const {
      receiver,
      deliveryAddress,
      mobile,
      phone,
      pickUpName,
    } = member;

    const {
      consignmentInfo,
      orderTime,
      pointOfServiceAddress,
      pointOfServiceName,
      price,
      productCode,
      productCount,
      productImg,
      productName,
    } = detailItem;
    // // console.log(consignmentInfo, orderTime, pointOfServiceAddress, pointOfServiceName, price, productCode, productCount, productImg, productName);


    let tempDetailArray = [];
    let tempDetailArrayItem = {
      receiver: receiver,
      deliveryAddress: deliveryAddress,
      mobile: mobile,
      phone: phone,
      pickUpName: pickUpName,
      consignment: [],
      product: {
        code: productCode,
        price: price,
        qty: productCount,
        image: productImg,
        name: productName
      }
    };

    // 確定 consignment 有東西的狀況下開始做資料 mapping
    if( consignmentInfo && consignmentInfo.length ) {
      consignmentInfo.map((consignmentInfoItem) => {
        console.log(consignmentInfoItem);
        /**
         * logisticHistories(貨運歷史) Array
         * carrier(貨運公司)
         * logisticCompany(貨運公司)
         * trackingId(貨運單追蹤ID)
        */
        const {
          completedDate,
          // consignemntPrice,
          consignmentCode,
          consignmentStatus,
          deliveryMode,
          // estSite,
          expectShipDate,
          installationDate,
          isTmall,
          logisticInfo,
          // qty,
          shippingDate
        } = consignmentInfoItem;

        let tempConsignmentItem = {
          status: consignmentStatus,
          code: consignmentCode,
          mode: deliveryMode,
          time: {
            start: orderTime,
            outOfWareHouse: shippingDate,
            expect: expectShipDate,
            installation: installationDate,
            finished: completedDate
          },
          logisticInfo: logisticInfo,
          config: {
            // 是否為天貓
            isTMall: isTmall,
          }
        };

        console.log('tempConsignmentItem:', tempConsignmentItem);
      });
    };

    // console.log('好的', tempDetailArrayItem);
  });
};

export const AllNewOrderListDetailData = (orderListDetail) => {

  const orderEntryList = orderListDetail.orderEntryList;

  return orderEntryList.map((orderListDetailItem) => {
    let tempConsignmentInfo = [];
    if (orderListDetailItem.consignmentInfo && orderListDetailItem.consignmentInfo.length) {
      orderListDetailItem.consignmentInfo.map((consignmentInfo)=> {

        let tempLogisticInfo = [];
        /**
         * logisticHistories(貨運歷史) Array
         * carrier(貨運公司)
         * logisticCompany(貨運公司)
         * trackingId(貨運單追蹤ID)
         * parametersForXinZhu(新竹貨運 貨單URL TOKEN)
        */
        
        if(consignmentInfo.logisticInfo && consignmentInfo.logisticInfo.length) {
          tempLogisticInfo = consignmentInfo.logisticInfo.map((logisticInfo) => {
            let tempLogisticHistories = logisticInfoFormatter(logisticInfo.logisticHistories);

            return {
              logisticHistories: tempLogisticHistories,
              carrier: logisticInfo.carrier,
              logisticCompany: logisticInfo.logisticCompany,
              parametersForXinZhu: logisticInfo.parametersForXinZhu,
              trackingId: logisticInfo.trackingId,
            }
          });
        };
        /**
         * isTmall(沒用到) 是不天貓
         * estSite(沒用到)
         * deliveryMode(沒用到) 運送模式
         * consignmentCode (貨運單號)
         * expectShipDate (出貨時間)
         * completedDate (訂單完成時間)
         * consignmentStatus(出貨狀態)
         */
        tempConsignmentInfo.push({
          shippingDate: consignmentInfo.shippingDate,
          consignmentCode: consignmentInfo.consignmentCode,
          expectShipDate: consignmentInfo.expectShipDate,
          completedDate: consignmentInfo.completedDate,
          consignmentStatus: consignmentInfo.consignmentStatus,
          logisticInfo: tempLogisticInfo
        });

        return tempConsignmentInfo;
      })
    }

    return {
      ...orderListDetailItem,
      consignmentInfo: tempConsignmentInfo,
    }
  })
};

function logisticInfoFormatter(logisticHistories) {
  if(logisticHistories && logisticHistories.length) {
    return logisticHistories.map(logisticHistory => {
      /**
       * statusDate(狀態)
       * area(地區)
       * statusDesc(貨況說明)
       * statusDisplay (狀態訊息)
       * statusCode (狀態代碼)
      */
      return {
        dateTime: logisticHistory.statusDate,
        area: logisticHistory.area,
        statusExplain: logisticHistory.statusDesc,
        statusInfo: logisticHistory.statusDisplay,
        statusCode: logisticHistory.statusCode
      }
    });
  } else {
    return [];
  };
};
